<child-header [title]="'Confirm Qty Update'" (closeEvent)="onNoClick()"></child-header>

<div mat-dialog-content>
<table>
  <tr>
    <td>
      Current charges
    </td>
    <td style="text-align: right;">
      <span class="color-red bold"> {{data.currenAmount |
        currency:'AUD':'symbol-narrow':'.2-2'}}</span>
    </td>
  </tr>
  <!-- <tr>
    <td>
      {{data.additionalOrRefundLabel}}
    </td>
    <td style="text-align: right;">
      <span class="color-red bold"> {{data.additionalAmount |
        currency:'AUD':'symbol-narrow':'.2-2'}}</span>
    </td>
  </tr>
  <tr>
    <td>
      Total amount for next billing
    </td>
    <td style="text-align: right;">
      <span class="color-red bold"> {{data.nextBillingAmount |
        currency:'AUD':'symbol-narrow':'.2-2'}}</span>
    </td>
  </tr> -->
  <tr>
    <td>
      Ongoing charges after next billing
    </td>
    <td style="text-align: right;">
      <span class="color-red bold"> {{data.newTermAmount |
        currency:'AUD':'symbol-narrow':'.2-2'}}</span>
    </td>
  </tr>

</table>
 
    <br />
  <p>Are you sure you want to change the quantity on renewal?</p>
</div>
<div class="nce-dialog-action">
  <button mat-button class="button button-red button-large nce-large-button continue" [disabled]="!data?.autorenew"
    (click)="continueSaveSubscription()">Schedule on Renewal</button>

  <button mat-button class="button button-red button-large nce-large-button continue"
    (click)="onNoClick()">Cancel</button>
</div>
